import { render, staticRenderFns } from "./BasePage.vue?vue&type=template&id=3e3f1666&scoped=true&"
import script from "./BasePage.vue?vue&type=script&lang=ts&"
export * from "./BasePage.vue?vue&type=script&lang=ts&"
import style0 from "./BasePage.vue?vue&type=style&index=0&id=3e3f1666&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3f1666",
  null
  
)

export default component.exports